<template>
  <div  class="container-fluid">
    <div class="row">
      <div class="col-sm-3">
        <custom-select style="width: 100%" name="ductos" id="ductos" :options="ductos" placeholder="DUCTO" @changeSelect="selectedDuctoEvent($event)"></custom-select>
    </div>               
  </div>    
  <div>
    <md-card md-with-hover v-for="(data, id) in this.siteData" :key="id" 
      @click.native="siteClick(data.site)"
      :style="[data.site.comm_online ? {'border-color': 'green'} : {'border-color': 'red'}]">   
      <md-ripple> 
        <div class="box">
          <div class="header">
            <i class="fa fa-signal box-icons" :style="[data.site.comm_online ? {'color': 'green'} : {'color': 'red'}]" aria-hidden="true"></i>
            <span class="header-text">{{data.site.name}}</span>   
          </div>

          <md-divider></md-divider>   

          <div class="box content">
            <span class="sub-header">{{data.section.name}}</span>  
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <i class="fa fa-map-marker card-icons" aria-hidden="true"></i>
                <span class="card-detail-text">
                  {{data.site.city + ', Km ' + data.site.km}}
                </span>            
              </div>                    
            </div> 

            <div class="md-layout md-gutter">    
              <div class="md-layout-item">
                <i class="fa fa-tint card-icons" :style="[data.site.pressure === 0 ? {'color': 'red'} : {'color': 'green'}]"  aria-hidden="true"></i>
                  <span class="card-detail-text">
                    {{data.site.pressure + ' kg/cm2'}}
                  </span>
                <div class="card-small-text">Presión</div>
              </div>                                
              <div class="md-layout-item">
                <i class="fa fa-power-off card-icons" :style="[data.site.enabled === 1 ? {'color': 'green'} : {'color': 'red'}]"  aria-hidden="true"></i>
                  <span class="card-detail-text">
                    {{data.site.enabled === 1 ? 'Encendido' : 'Apagado'}}
                  </span>
                <div class="card-small-text">Estado</div>
              </div>            
            </div>
          </div>

          <md-divider></md-divider>   

          <div class="footer">
            <i class="fa fa-clock-o box-icons" aria-hidden="true"></i>
            <span class="footer-text">Último evento: {{data.site.insertTimestamp}}</span>  
          </div>
        </div>
      </md-ripple>            
    </md-card>
  </div>
</div>
</template>

<script>
import CustomSelect from 'reusable/Select'
export default {  
  data() {
    return {
      siteData: [],
      ductos: [],
      selectedDucto: null,
      timer: null,
    }
  },
  components: {
    CustomSelect
  },
  methods: {
    fillSite() {
      this.siteData = [];
      let ducts = this.$store.getters.GET_HOME_DUCTOS_TABLE
      if(!ducts) {
        return;
      }
      Object.keys(ducts).forEach(idSection => {
        let section = ducts[idSection];
        if(!this.ductos.find(d => d.value == section.id)) {
          this.ductos.push({name: section.name, value: section.id});
        }
        if(this.selectedDucto == null || this.selectedDucto == section.id) {
          Object.keys(section.sites).forEach(idSite => {
            let site = section.sites[idSite];
            this.siteData.push({section: section, site: site});
          });
        }
      })
    },
    loadHealth() {
      this.$store.dispatch('LOAD_DUCTOS').then(() => {
        this.fillSite();
      });
    },
    siteClick(site) {
      const section_id = site.section_id;
      const site_id = site.site_id;

      let routeUrl = this.$router.resolve({
        path: `/sitio/${section_id}/${site_id}`,
      });
      window.open(routeUrl.href, '_blank');

      return false;
    },
    selectedDuctoEvent(e) {
      let d = document.querySelector(`#${e}`)
      this.selectedDucto = d.value;
      this.fillSite();
    }
  },
  created() {
    this.loadHealth();
    this.timer = setInterval(this.loadHealth, 150000);
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }  
}


</script>

<style lang="scss" scoped>
  .md-card {
    width: 240px;
    height: 11.5rem;
    margin: 6px;
    display: inline-block;
    vertical-align: top;
    border-radius: 10px;
    border-width: 1px;
    border-style: solid;
    border-color: rgb(223,223,223);   
    background: rgb(247, 247, 247);
  }

  .box-icons {
    font-size: small; 
    color: #166FB8; 
    margin-top: 5px;
  }

  .card-normal-text {
    font-size: 12px;
  }

  .card-detail-text {
    font-size: smaller;
  }

  .card-small-text {
    font-size: xx-small;
  }

.box {
  display: flex;
  flex-flow: column;
  height: 100%;
}

.box .content {
  flex: 1 1 auto;
  padding: 4px 8px 4px 8px; 
  background-color: white;
}

.box .header {
  flex: 0 1 auto;
  padding: 4px 6px 4px 6px;  
  /* The above is shorthand for:
  flex-grow: 0,
  flex-shrink: 1,
  flex-basis: auto
  */
}

.box .header .header-text {
  font-size: small;  
  color: black;
}

.box .footer {
  flex: 0 1 auto;
  padding: 4px 6px 4px 6px;  
}  

.box .footer .footer-text {
  font-size: smaller;  
  color: rgb(128, 128, 128)
}

.box .sub-header {
  font-size: small;  
  color: rgb(128, 128, 128);
  margin: 4px 0px 4px 0px;
}

</style>



// WEBPACK FOOTER //
// Salud.vue?4e5e5057